const LANGUAGES = [
  {value: 'English', label: 'English'},
  {value: 'French', label: 'Français'},
]

export default LANGUAGES
